<script>
  import { checkbox } from 'vue-strap';
  import estados from '~js/estados';
  import tiposQuadro from '~js/tipos-quadro';
  
  export default {
    components: { checkbox },
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
      edicao: {
        type: Boolean,
        required: false, 
        default: false, 
      }
    },
    data() {
      return {
        estados: estados,
        tiposQuadro: tiposQuadro,
        configuracao: this.$storage.configuracao(),
        pertenceEquipe: true,
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
    },
    computed: {
    },
    mounted() {
      $('label.checkbox')
        .css('margin-top', 0)
        .css('margin-bottom', 5)
        .addClass('control-label');
    }
  }
</script>

<template>
  <div>
    
    <div class="row">
      <div class="col-sm-8">
        <div class="form-group required" :class="{'has-error': errors.has('nomeTerceiro')}">
          <label class="control-label" for="nome-terceiro">Nome do beneficiário</label>

          <input 
              type="text"
              class="form-control"
              id="nome-terceiro"
              v-model="solicitacao.nomeTerceiro"
              data-vv-name="nomeTerceiro"
              data-vv-as="Nome do beneficiário"
              v-validate="'required'"
              maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeTerceiro')">{{ errors.first('nomeTerceiro') }}</p>
        </div>
      </div>
      
      <div class="col-sm-4">
        <div class="form-group required">
          <label class="control-label" for="documento-terceiro">CPF do beneficiário</label>

          <input 
              type="text"
              class="form-control"
              id="documento-terceiro"
              v-model="solicitacao.documentoTerceiro"
              maxlength="20"
              disabled>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-3">
        <div :class="['form-group', {'has-error': errors.has('tipoQuadro'), required: solicitacao.pertenceQuadro}]">
          <checkbox v-model="solicitacao.pertenceQuadro" :true-value="true" type="success">Pertence ao quadro? Qual?</checkbox>

          <select 
              id="tipo-quadro"
              class="form-control"
              v-model="solicitacao.tipoQuadro"
              data-vv-name="tipoQuadro"
              data-vv-as="tipo do quadro"
              v-validate="solicitacao.pertenceQuadro ? 'required' : ''"
              :disabled="!solicitacao.pertenceQuadro">
            <option value="">Selecione...</option>
            <option :value="tipoQuadro.id" v-for="tipoQuadro in tiposQuadro">{{ tipoQuadro.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('tipoQuadro')">{{ errors.first('tipoQuadro') }}</p>
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group">
          <label class="control-label" for="matricula">Matrícula</label>

          <input
              id="matricula"
              class="form-control"
              type="text"
              v-model="solicitacao.matricula"
              maxlength="20">
        </div>
      </div>
      
      <div class="col-lg-3">
        <div class="form-group">
          <label class="control-label" for="siafi">SIAPE</label>

          <input
              id="siafi"
              class="form-control"
              type="text"
              v-model="solicitacao.siafi"
              maxlength="20">
        </div>
      </div>
      
      <div class="col-lg-3">
        <div :class="['form-group', {'has-error': errors.has('inssOutraFonteValor'), 'required': solicitacao.inssOutraFonte}]">
          <checkbox v-model="solicitacao.inssOutraFonte" :true-value="true" type="success">
            <small>Reteve INSS este mês em outra fonte? R$</small>
          </checkbox>
          
          <input
              id="inss-outra-fonte-valor"
              class="form-control text-right"
              type="text"
              v-mascara="'moeda'"
              v-model="solicitacao.inssOutraFonteValor"
              data-vv-name="inssOutraFonteValor"
              data-vv-as="valor inss"
              v-validate="solicitacao.inssOutraFonte ? 'required' : ''"
              :disabled="!solicitacao.inssOutraFonte">

          <p class="text-danger" v-show="errors.has('inssOutraFonteValor')">{{ errors.first('inssOutraFonteValor') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('dataNascimento')}">
          <label class="control-label" for="nascimento">Data de nascimento</label>

          <input id="nascimento"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.dataNascimento"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 data-vv-name="dataNascimento"
                 data-vv-as="data de nascimento"
                 v-validate="'required|date_format:DD/MM/YYYY'">

          <p class="text-danger" v-show="errors.has('dataNascimento')">{{ errors.first('dataNascimento') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="identidade">Identidade</label>

          <input id="identidade"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.identidade"
                 maxlength="20">
        </div>
      </div>

      <div class="col-lg-3" :class="{'has-error': errors.has('inss')}">
        <div class="form-group">
          <label class="control-label" for="inss">INSS <small class="text-muted">(apenas números)</small></label>

          <input id="inss"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.inss"
                 v-mascara="'inss'"
                 data-vv-name="inss"
                 data-vv-as="inss"
                 data-vv-delay="1000"
                 readonly="!this.configuracao.ObrigatorioPISPASEPINSSWeb"
                 v-validate="`inss|inssPisUnico:${this.solicitacao.documentoTerceiro}`">

          <p class="text-danger" v-show="errors.has('inss')">{{ errors.first('inss') }}</p>
        </div>
      </div>

      <div class="col-lg-3" :class="{'has-error': errors.has('pispasep')}">
        <div class="form-group">
          <label class="control-label" for="pispasep">PISPASEP <small class="text-muted">(apenas números)</small></label>

          <input id="pispasep"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.pisPasep"
                 v-mascara="'pispasep'"
                 data-vv-name="pispasep"
                 data-vv-as="pis/pasep"
                 data-vv-delay="1000"
                 readonly="!this.configuracao.ObrigatorioPISPASEPINSSWeb"
                 v-validate="`pispasep|inssPisUnico:${this.solicitacao.documentoTerceiro}`">

          <p class="text-danger" v-show="errors.has('pispasep')">{{ errors.first('pispasep') }}</p>
        </div>
      </div>

      <div class="col-lg-2" :class="{'has-error': errors.has('ccm')}">
        <div class="form-group">
          <label class="control-label" for="ccm">CCM</label>

          <input id="ccm"
                 class="form-control"
                 type="text"
                 v-model="solicitacao.numCmc"
                 data-vv-name="ccm"
                 data-vv-as="CCM"
                 maxlength="30">

          <p class="text-danger" v-show="errors.has('ccm')">{{ errors.first('ccm') }}</p>
        </div>
      </div>
    </div>
      
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group required" :class="{'has-error': errors.has('endereco')}">
          <label class="control-label" for="endereco">Endereço</label>

          <input
              id="endereco"
              class="form-control"
              type="text"
              v-model="solicitacao.endereco"
              data-vv-name="endereco"
              data-vv-as="endereço"
              v-validate="'required'"
              maxlength="60">

          <p class="text-danger" v-show="errors.has('endereco')">{{ errors.first('endereco') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('numero')}">
          <label class="control-label" for="numero">Número</label>

          <input
              id="numero"
              class="form-control"
              type="text"
              v-model="solicitacao.numero"
              data-vv-name="numero"
              data-vv-as="número"
              v-validate="'required'"
              maxlength="10">

          <p class="text-danger" v-show="errors.has('numero')">{{ errors.first('numero') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label" for="complemento">Complemento</label>

          <input
            id="complemento"
            class="form-control"
            type="text"
            v-model="solicitacao.complemento"
            maxlength="80">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('bairro')}">
          <label class="control-label" for="bairro">Bairro</label>

          <input 
              type="text"
              class="form-control"
              id="bairro"
              v-model="solicitacao.bairro"
              data-vv-as="bairro"
              data-vv-name="bairro"
              v-validate="'required'"
              maxlength="60">

          <p class="text-danger" v-show="errors.has('bairro')">{{ errors.first('bairro') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cidade')}">
          <label class="control-label" for="cidade">Cidade</label>

          <input 
              type="text"
              class="form-control"
              id="cidade"
              v-model="solicitacao.cidade"
              data-vv-as="cidade"
              data-vv-name="cidade"
              v-validate="'required'"
              maxlength="60">

          <p class="text-danger" v-show="errors.has('cidade')">{{ errors.first('cidade') }}</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('uf')}">
          <label class="control-label" for="uf">Estado</label>

          <select 
              id="uf"
              class="form-control"
              v-model="solicitacao.uf"
              data-vv-as="estado"
              data-vv-name="uf"
              v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="estado.sigla" v-for="estado in estados">{{ estado.nome }}</option>
          </select>
          
          <p class="text-danger" v-show="errors.has('uf')">{{ errors.first('uf') }}</p>
        </div>
      </div>
      
      <div class="col-sm-3">
        <div class="form-group required" :class="{'has-error': errors.has('cep')}">
          <label class="control-label" for="cep">CEP</label>

          <input type="text"
                 class="form-control"
                 id="cep"
                 v-model="solicitacao.cep"
                 data-vv-as="cep"
                 data-vv-name="cep"
                 v-mascara="'cep'"
                 maxlength="9"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('cep')">{{ errors.first('cep') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneResidencial')}">
          <label class="control-label" for="telefone-residencial">Tel. residencial</label>

          <input
              type="text"
              class="form-control"
              id="telefone-residencial"
              v-mascara="'telefone'"
              v-model="solicitacao.telefoneResidencial"
              data-vv-as="tel. residencial"
              data-vv-name="telefoneResidencial"
              v-validate="'required'">

          <p class="text-danger" v-show="errors.has('telefoneResidencial')">{{ errors.first('telefoneResidencial') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="telefone-comercial">Tel. comercial</label>

          <input
              id="telefone-comercial"
              class="form-control"
              type="text"
              v-mascara="'telefone'"
              v-model="solicitacao.telefoneComercial">
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group">
          <label class="control-label" for="fax">Fax</label>

          <input
              id="fax"
              class="form-control"
              type="text"
              v-mascara="'telefone'"
              v-model="solicitacao.fax">
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group required" :class="{'has-error': errors.has('emailTerceiro')}">
          <label class="control-label" for="email-terceiro">E-mail do beneficiário <small class="text-muted">(Para mais de um email separar utilizando ";")</small></label>

          <input
              type="text"
              class="form-control"
              id="email-terceiro"
              v-model="solicitacao.emailTerceiro"
              data-vv-as="e-mail"
              data-vv-name="emailTerceiro"
              v-validate="'required'"
              maxlength="300"
              v-caracteres-email>

          <p class="text-danger" v-show="errors.has('emailTerceiro')">{{ errors.first('emailTerceiro') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<style>
  .select2-container--bootstrap .select2-results__option[aria-disabled=true] {
    color: #ED5565!important;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento-rateio/fisica/componentes/compartilhado/FormDadosCadastrais.vue